import {Deserializable} from '../deserializable';
import {DoMat} from '../danhmuc/domat';
import {LoaiVanBan} from '../danhmuc/loaivanban';
import {DonViNgoai} from '../danhmuc/donvingoai';
import {DoKhan} from '../danhmuc/dokhan';

export  class HoSoLuuTru implements Deserializable
{
  public  id: number;
  public  soVanBan: string;
  public  ngayKetThuc: string;
  public  doMatId: number;
  public  kyHieu: string;
  public  ngayKy: string;
  public  nguoiKy: string;
  public  loaiVanBanId: number;
  public  coQuanBanHanhId: number;
  public  trichYeu: string;
  public  chuyenDe: string;
  public  tuKhoa: string;
  public  diaChiBaoQuan: string;
  public  maSoTaiLieu: string;
  public  soTrang: string;
  public  staffId: number;
  public  created: Date;
  public  modified: Date;
  public  doMat: DoMat;
  public  loaiVanBan: LoaiVanBan;
  public  coQuanBanHanh: DonViNgoai;

  deserialize(input: any): this {
    Object.assign(this, input);

    this.coQuanBanHanh = input.coQuanBanHanh!= null ? new DonViNgoai().deserialize(input.coQuanBanHanh): null;
    this.doMat = input.doMat != null ? new DoMat().deserialize(input.doMat): null;
    this.loaiVanBan = input.loaiVanBan != null ? new LoaiVanBan().deserialize(input.loaiVanBan): null;

    return this;
  }
}
